<div appModalSwipe class="modal l-wrapper" [ngClass]="{'modal--mobile': breakPoint.isMobile}">
  <div *ngIf="!breakPoint.isMobile" class="modal__overlay" (click)="closeModal()"></div>
  <div *ngIf="breakPoint.isMobile" appOverlaySwipe class="modal__overlay"></div>

  <div appBottomSwipeSheet (swipeAnimationEnd)="closeModal()"
       class="modal__container _m bottom-sheet">
    <form class="modal__content" [formGroup]="form" *ngIf="data$ | async as data">

      <div *ngIf="breakPoint.isMobile" class="bottom-sheet__line"></div>

      <div class="modal__close">
        <button *ngIf="!breakPoint.isMobile" type="button" class="button-icon button-icon--th-ctrl" (click)="closeModal()">
          <i class="icomoon icomoon--close"></i>
        </button>

        <button *ngIf="breakPoint.isMobile" type="button" class="button-icon button-icon--th-ctrl" (click)="closeMobileModal()">
          <i class="icomoon icomoon--close"></i>
        </button>
      </div>

      <div class="modal__body l-wrapper">
        <div class="product-detail">
          <ng-container *ngIf="relatedProducts$ | async as relatedProducts">
            <div class="product-detail__related" *ngIf="relatedProducts.length">
              <div class="product-detail__image _placeholder"></div>
              <div class="related-list">
                <h3 class="related-list__header h3" i18n="@@YouMayAlsoLike">You may also like</h3>
                <div class="related-list__inner l-wrapper-push">
                  <div class="related-list__item" *ngFor="let product of relatedProducts">
                    <app-related-card [product]="product"></app-related-card>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="product-detail__photo">
            <div class="product-detail__image">
              <div class="product-detail__img">
                <picture class="cover-picture" *ngIf="currentSize.buttonImage['src']; else photoPlaceholder">
                  <source srcset="{{ currentSize.buttonImage['376x276x100.webp'] }}, {{ currentSize.buttonImage['752x552x100.webp'] }} 2x">
                  <img ngSrc="{{ currentSize.buttonImage['src'] }}" loading="auto" [alt]="data.name" width="200" height="100" appPictureFallback>
                </picture>
                <div class="product-detail__tags" *ngIf="data.labels && !!data.labels.length">
                  <div class="tag-list">
                    <ng-container *ngFor="let label of data.labels">
                      <button class="tag" (click)="setLabelFilter(label.name)">{{ label.name }}</button>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-detail__main">
            <div class="product-detail__head h1">
              <span data-cy="productDetailTitle">{{ data.name }}</span>
              <app-product-unit
                *ngIf="currentSize.portionWeightGrams"
                [unit]="currentSize.measureUnitType"
                [value]="currentSize.portionWeightGrams"
              ></app-product-unit>
            </div>

            <div class="product-detail__row _price" [ngClass]="{'is-last': !data.itemSizes || data.itemSizes.length <= 1}">
              <app-product-price [price]="totalPrice"></app-product-price>
            </div>

            <div class="product-detail__row _size" *ngIf="data.itemSizes && data.itemSizes.length > 1">
              <app-fresh-size-picker
                [sizes]="data.itemSizes"
                (pickSize)="onChangeSize($event)"
              ></app-fresh-size-picker>
            </div>

            <div class="product-detail__wrap">
              <div class="product-detail__row" *ngIf="data.description">
                <div class="product-detail__subtitle h5" i18n="@@IngredientsTitle">Ingredients</div>
                <div class="product-detail__text">
                  {{ data.description }}
                </div>
              </div>

              <div class="product-detail__row" *ngIf="currentSize && currentSize.nutritionPerHundredGrams
                && currentSize.portionWeightGrams && currentSize.nutritionPerHundredGrams
                && currentSize.nutritionPerHundredGrams.energy || data.allergens.length">

                <div *ngIf="currentSize.nutritionPerHundredGrams && currentSize.nutritionPerHundredGrams.energy">
                  <h5 class="product-detail__subtitle h5" i18n="@@PortionListTitle">In one portion</h5>
                </div>
                <app-fresh-portion-list
                  *ngIf="currentSize.nutritionPerHundredGrams && currentSize.nutritionPerHundredGrams.energy"
                  [size]="currentSize"
                  [nutrition]="currentSize.nutritionPerHundredGrams"
                ></app-fresh-portion-list>
              </div>

              <div class="product-detail__row" *ngIf="data.allergens && !!data.allergens.length">
                <div class="product-detail__subtitle h5" i18n="@@AllergensListTitle">Allergens</div>
                <div class="allergen-list">
                  <div class="allergen-list__inner l-wrapper-push">
                    <ng-container *ngFor="let allergen of data.allergens">
                      <button class="allergen-list__item small" (click)="setAllergenFilter(allergen.name)">
                        <div class="allergen-list__chip small">{{ allergen.name | lowercase }}</div>
                      </button>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div class="product-detail__row product-detail__row-additional"
                 *ngIf="currentSize && currentSize.itemModifierGroups
                 && currentSize.itemModifierGroups[0]?.items?.length"
                 formArrayName="modifiers">
              <ng-container *ngFor="let modifierGroup of currentSize.itemModifierGroups; let i = index">
                <div class="product-detail__additional"
                     *ngIf="modifierGroup.childModifiersHaveMinMaxRestrictions
                     || modifierGroup.restrictions.maxQuantity">
                  <app-modifier-list
                    [formControlName]="i"

                    [modifierGroup]="modifierGroup"
                    [isGroupModifier]="modifierGroup.restrictions.maxQuantity === 1"

                    [minCount]="modifierGroup.restrictions.minQuantity"
                    [maxCount]="modifierGroup.restrictions.maxQuantity"
                    [byDefault]="modifierGroup.restrictions.byDefault"

                    (changeModifiers)="onChangeModifiers(modifierGroup)"
                  ></app-modifier-list>

                  <div class="product-detail__errors" *ngIf="!form.valid">
                    <span class="error small" i18n="@@ErrorMessageModifiersCount">Select the required modifiers</span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

        </div>
      </div>

      <div class="modal__footer l-wrapper">
        <div class="basket-panel">
          <div class="basket-panel__left" *ngIf="!breakPoint.isMobile">
            <app-product-price [price]="totalPrice"></app-product-price>
          </div>

          <div class="basket-panel__right" *ngIf="isBasketMode$ | async">
            <div class="basket-panel__counter">
              <app-counter
                (changeValue)="onChangeCount()"
                [min]="1"
                [max]="data.balance ?? 10000"
                [isDisabled]="data.balance === 0"
                formControlName="count"
              ></app-counter>
            </div>

            <div class="basket-panel__ctrl">
              <button type="button"
                      class="button button--th-main _rounded" (click)="onAddToBasket()"
                      [disabled]="data.balance === 0 || !form.valid"
              >
                <span class="button__text" i18n="@@ToCartButtonText">To cart</span>
              </button>
            </div>

            <div class="basket-panel__price" *ngIf="breakPoint.isMobile" (click)="onAddToBasket()">
              <span class="price" *ngIf="totalPrice !== 0;">
                <app-price [price]="totalPrice"></app-price>
              </span>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>

<ng-template #photoPlaceholder>
  <i class="icomoon icomoon--dish-placeholder"></i>
</ng-template>
